import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const types = {
    ADD_TO_CART: 'ADD_TO_CART',
    REMOVE_FROM_CART: 'REMOVE_FROM_CART',
    CHANGE_PRODUCT_QUANTITY: 'CHANGE_PRODUCT_QUANTITY',
    CHANGE_PRODUCT_SERVICE_TYPE: 'CHANGE_PRODUCT_SERVICE_TYPE',
    CLEAR_CART: 'CLEAR_CART',
    TOGGLE_ADDITIONAL_SERVICE: 'TOGGLE_ADDITIONAL_SERVICE',
    CHANGE_LOCALE: 'CHANGE_LOCALE',
    SAVE_MARKETING_CONSENT_STATE: 'SAVE_MARKETING_CONSENT_STATE',
    SAVE_ANALYTICS_CONSENT_STATE: 'SAVE_ANALYTICS_CONSENT_STATE'
};

const state = {
    cart: JSON.parse(localStorage.getItem("mt_cart")),
    cartQuantity: Number(localStorage.getItem("mt_cart_q")),
    locale: localStorage.getItem("locale"),
    marketingConsentState: Boolean(localStorage.getItem("cookie:marketing") === 'true'),
    analyticsConsentState: Boolean(localStorage.getItem("cookie:analytics") === 'true')
};

const getters = {
    getCart: state => state.cart,
    getCartQuantity: state => state.cartQuantity,
    getLocale: state => state.locale,
    getMarketingConsentState: state => state.marketingConsentState,
    getAnalyticsConsentState: state => state.analyticsConsentState
};

const actions = {
    addToCart({commit}, item) {
        commit(types.ADD_TO_CART, item);
    },

    removeFromCart({commit}, item) {
        commit(types.REMOVE_FROM_CART, item);
    },

    changeProductQuantity({commit}, item) {
        commit(types.CHANGE_PRODUCT_QUANTITY, item);
    },

    changeProductServiceType({commit}, item) {
        commit(types.CHANGE_PRODUCT_SERVICE_TYPE, item);
    },

    clearCart({commit}) {
        commit(types.CLEAR_CART);
    },

    toggleAdditionalService({commit}, item) {
        commit(types.TOGGLE_ADDITIONAL_SERVICE, item);
    },

    changeLocale({commit}, locale) {
        commit(types.CHANGE_LOCALE, locale);
    },

    saveMarketingConsentState({commit}, consentState) {
        commit(types.SAVE_MARKETING_CONSENT_STATE, consentState);
    },

    saveAnalyticsConsentState({commit}, consentState) {
        commit(types.SAVE_ANALYTICS_CONSENT_STATE, consentState);
    }
};

const mutations = {
    [types.ADD_TO_CART] (state, item) {
        if (state.cart == null)
            state.cart = []

        let updated = false;
        for (let position in state.cart) {
            if (state.cart[position].id === item.id) {
                state.cart[position].quantity = state.cart[position].quantity + item.quantity
                updated = true
            }
        }
        if (!updated)
            state.cart.push(item)

        state.cartQuantity = state.cart.length

        localStorage.setItem('mt_cart', JSON.stringify(state.cart))
        localStorage.setItem('mt_cart_q', state.cartQuantity)
    },

    [types.REMOVE_FROM_CART] (state, item) {
        if (state.cart == null)
            state.cart = []

        for (let position in state.cart) {
            if (state.cart[position].id === item.id) {
                state.cart.splice(position, 1)
                break
            }
        }

        state.cartQuantity = state.cart.length

        localStorage.setItem('mt_cart', JSON.stringify(state.cart))
        localStorage.setItem('mt_cart_q', state.cartQuantity)
    },

    [types.CHANGE_PRODUCT_QUANTITY] (state, item) {
        if (state.cart == null)
            state.cart = []

        for (let position in state.cart) {
            if (state.cart[position].id === item.productId) {
                state.cart[position].quantity = item.quantity
            }
        }
        state.cartQuantity = state.cart.length

        localStorage.setItem('mt_cart', JSON.stringify(state.cart))
        localStorage.setItem('mt_cart_q', state.cartQuantity)
    },

    [types.CHANGE_PRODUCT_SERVICE_TYPE] (state, item) {
        if (state.cart == null)
            state.cart = []

        for (let position in state.cart) {
            if (state.cart[position].id === item.productId) {
                state.cart[position].variation = item.serviceType
            }
        }

        localStorage.setItem('mt_cart', JSON.stringify(state.cart))
    },

    [types.CLEAR_CART] (state) {
        state.cart = []
        state.cartQuantity = state.cart.length

        localStorage.setItem('mt_cart', JSON.stringify(state.cart))
        localStorage.setItem('mt_cart_q', state.cartQuantity)
    },

    [types.TOGGLE_ADDITIONAL_SERVICE] (state, item) {
        if (state.cart == null)
            state.cart = []

        for (let position in state.cart) {
            if (state.cart[position].id === item.productId) {
                for (let servicePosition in state.cart[position].availableAdditionalServices) {
                    if (state.cart[position].availableAdditionalServices[servicePosition].id === item.additionalServiceId) {
                        state.cart[position].availableAdditionalServices[servicePosition].selected =
                            !state.cart[position].availableAdditionalServices[servicePosition].selected;

                        localStorage.setItem('mt_cart', JSON.stringify(state.cart))
                        return
                    }
                }
            }
        }
    },

    [types.CHANGE_LOCALE] (state, locale) {
        state.locale = locale
        localStorage.setItem('locale', locale)
    },

    [types.SAVE_MARKETING_CONSENT_STATE] (state, consentState) {
        state.marketingConsentState = consentState
        localStorage.setItem('cookie:marketing', consentState)
    },

    [types.SAVE_ANALYTICS_CONSENT_STATE] (state, consentState) {
        state.analyticsConsentState = consentState
        localStorage.setItem('cookie:analytics', consentState)
    }
};

const store = new Vuex.Store({
    state,
    getters,
    actions,
    mutations
});

export default store;
